<div class="wrapper-orders-tabs">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Orders" | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="section-tabs">
    <div
      class="tab-switcher"
      role="tablist"
      [attr.aria-label]="'Orders' | translate"
    >
      <button
        type="button"
        role="tab"
        class="tab-item"
        [class.active]="activeTab === 'orders'"
        [attr.aria-selected]="activeTab === 'orders'"
        (click)="selectTab('orders')"
      >
        <i class="fi fi-rr-users-alt tab-icon"></i>
        <span class="tab-label">{{ "Orders" | translate }}</span>
      </button>
      <button
        type="button"
        role="tab"
        class="tab-item"
        [class.active]="activeTab === 'subscriptions'"
        [attr.aria-selected]="activeTab === 'subscriptions'"
        (click)="selectTab('subscriptions')"
      >
        <i class="fi fi-rr-shopping-cart tab-icon"></i>
        <span class="tab-label">{{ "Subscriptions" | translate }}</span>
      </button>
    </div>
  </div>

  <div class="tab-content">
    <orders-history
      *ngIf="activeTab === 'orders'"
      [embedded]="true"
    ></orders-history>
    <order-subscription
      *ngIf="activeTab === 'subscriptions'"
      [embedded]="true"
    ></order-subscription>
  </div>
</div>
